<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div>
		<b-modal ref="incompleteStepModal" hide-footer title="Attention !">
			<p class="my-4">Vous ne pouvez pas ajouter une étape incomplète dans la pile de compilation...</p>
		</b-modal>
		<b-modal ref="modalError" hide-footer title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<b-modal :size="'lg'"
			ref="previewModal"
			:title="projectName"
			@hidden="stopVideo"
			centered
			hide-footer
		>
			<div class="embed-responsive embed-responsive-16by9">
				<video class="embed-responsive-item video-popup"
					:src="videoPath"
					ref="playerpreview"
					controls
					height="600"
					width="800"></video>
			</div>
			<hr />
			<b-row>
				<b-col><a target="_blank"  class="btn btn-download" :href="videoPath" :download="safe_project_name" v-if="false">Télécharger</a>
				</b-col>
				<b-col md="auto">
					<b-button @click="closePreview" class="btn-close-preview">OK</b-button>
				</b-col>
			</b-row>
		</b-modal>
		<b-modal :size="'lg'"
			ref="notificationModal"
			:title="projectName"
			@hidden="gotoDashboard"
			@ok="send_notif"
			ok-title="Valider ce film et avertir le service communication"
			cancel-title="Annuler">
			<div class="embed-responsive">
				Votre film est finalisé, si celui-ci correspond à ce que vous attendez, vous pouvez en informer le service communication en cliquant sur le bouton ci-desssous. Notez qu'il est impératif que vous ayez l'accord du service communication avant de pouvoir diffuser votre film. Les équipes en charge de valider votre contenu vous contacterons rapidement sur l'email que vous avez utilisé pour vous connecter.
			</div>
		</b-modal>
		<b-modal ref="loaderModal"
			hide-footer
			title="Chargement...">
			<throbber />
			<p class="my-4">Veuillez patienter pendant la création de votre vidéo</p>
		</b-modal>
		<b-modal ref="finalDestLangModal"
			hide-footer
			centered
			:title="titleDestLangModal"
			size="lg"
			style="color:#004F9E">
			<b-row>
				<div class="subtitle_box">
					<button class="btn subtitle_btn" v-for="(dest_lang, index) in destinationLanguages" :key="index"
						@click="getLanguagesId(index)"
						:class="{ selected: dest_lang.isSelected }">
						<img :src="dest_lang.img">
						<p>{{ $t("lang." + dest_lang.lang) }}</p></button>
				</div>
				<p v-if="this.destLangWarning.length > 0" style="color:#004F9E">{{ destLangWarning }}</p>
			</b-row>
			<b-row>
				<b-col v-if="true" class="col-left">
					<b-button class="btn-export"
						@click="sendDatas('default')">{{ $t("Final.export") }}
					</b-button>
				</b-col>
				<b-col v-if="false" class="col-left">
					<b-button class="btn-export"
						@click="sendDatas('hd')">{{ $t("Final.export_1080hd") }}
					</b-button>
				</b-col>
				<b-col v-if="false" class="col-right">
					<b-button class="btn-export"
						@click="sendDatas('square')">{{ $t("Final.export_1080sq") }}
					</b-button>
				</b-col>
				<b-col v-if="false" class="col-right">
					<b-button class="btn-export"
						@click="sendDatas('square')">{{ $t("Final.export_1200sq") }}
					</b-button>
				</b-col>
			</b-row>
		</b-modal>
		<div class="row">
			<div class="">
				<label style="color: #224B93;">{{ $t("Final.select") }}</label>
				<b-form-group class="scrollpanel">
					<draggable v-model="steps" :options="dragEnableOptions">
						<transition-group name="list-complete">
							<div class="list_steps"
								v-for="(step, index) in this.steps"
								:key="index+1"
								:style="step.isCompleted === true ? stepFormLabelCompleted : stepFormLabelNotCompleted"
								:draggable="step.groupId === 'Outro'">
								<i class="fas fa-align-justify step-icon" style="margin-right: 5px"></i>
								<!--								<span class="step-name">{{ step.stepName }}</span>-->
								<span class="step-name">{{ $t('StepsList.' + step.translationId) }}</span>
								<span class="step-info" v-if="step.title">{{ step.title }}</span>
								<input class="checkbox_steps"
									type="checkbox"
									:checked="step.isCompleted"
									@click="check($event, step, index)"
									:id="index"
									:value="step.stepName"
									ref="checkboxSteps">
							</div>
						</transition-group>
					</draggable>
				</b-form-group>

				<div class="form-group">
					<label>{{ $t("Button.volume_music") }} {{ music_volume }}%<br /><input type="range" id="music_volume" name="music_volume"
						min="0" max="100" step="10" v-model="music_volume"></label>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-lg-12 mt-4">
				<button class="btn btn-valid"
					@click="selectDestLang">{{ $t("Button.validate_selection") }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import Draggable from "vuedraggable";
import {EventBus} from "../../event/event-bus.js";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Final",
	components: {
		Draggable,
		throbber,
		lottie_error,
	},
	props: {
		allSteps: Array,
		projectName: String,
	},
	data() {
		return {
			selected: [],
			stepNames: [],
			steps: [],
			tmpArray: [],
			text_error: "",
			videoPath: "",
			finalDestLang: "",
			countDestLang: 0,
			titleDestLangModal: "",
			destinationLanguages: [],
			destLangWarning: "",
			music_volume: 50,
			enableOptions: process.env.VUE_APP_HAS_DRAG_N_DROP,
			indeterminate: false,
			primaryColor: process.env.VUE_APP_PRIMARY_COLOR,
			stepFormLabelCompleted: {
				"font-size": "14px",
				"color": "#224B93",
			},
			stepFormLabelNotCompleted: {
				"font-size": "14px",
				"opacity": "0.5",
				"color": "#224B93",
				"display": "none",
			},
			dragEnableOptions: {group: "people", disabled: !process.env.VUE_APP_HAS_DRAG_N_DROP},
		};
	},
	activated() {
		try { // valid
			let $this = this;
			EventBus.$on("setLanguage", lang => {
				$this.$i18n.locale = lang;
			});
			this.getDatas();
		} catch(e) {
			console.log(e);
		}
	},
	deactivated() {
		this.$destroy();
	},
	computed: {
		stepsArray: {
			get() {
				if (this.steps !== undefined) {
					return this.steps;
				}
				else {
					return this.tmpArray;
				}
			},
			set(v) {
				this.steps = v;
			},
		},
		safe_project_name: {
			get() {
				let name = this.projectName.trim() || "Nouveau projet";
				return name.replace(/[^a-z0-9]/gi, "_") + ".mp4";
			},
		},
	},
	methods: {
		getDatas() {
			let $this = this;
			let array = [];
			axios
			.get(BASE_URL + "/public/api/projects/" + this.$route.params.id + "/visiblesSteps",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			)
			.then(function (response) {
				$this.projectName = response.data.project.data.name;
				let data = response.data.project.data.steps;
				$this.music_volume = response.data.project.data.music_volume;

				data.forEach(function (item, index, test) {
					if (item.groupId === "Outro") {
						$this.draggableIndex = index;
					}
					if (item.groupId === "Outro" || item.groupId === "Music") {
						item.isDraggable = false;
						item.fixed = true;
					}
					else {
						item.isDraggable = true;
						item.fixed = false;
					}
					if (item.isCompleted) {
						item.checked = true;
						array.push(item);
						$this.tmpArray.push(item);
					}
				});
				$this.steps = array;
			}).catch(error => {
				console.log(error);
				this.text_error = this.$root.$t("Errors.retrieving");
				this.$refs.modalError.show();
			});
		},
		checkMove(evt) {
			if (evt.draggedContext.element.isDraggable && (evt.draggedContext.futureIndex < this.draggableIndex)) {
				return evt.draggedContext.element.isDraggable;
			}
			else {
				this.orderList();
			}
		},
		orderList() {
			this.steps = this.steps.sort((one, two) => {
				return one.order - two.order;
			});
		},
		check: function (event, step, index) {
			if (event.target.checked) {
				if (step.isCompleted !== true) {
					this.$refs.incompleteStepModal.show();
					event.target.checked = false;
					this.steps[index].checked = false;
				}
				else {
					step.checked = true;
					this.steps[index].checked = true;
					step.isSelected = true;
				}
			}
			else {
				step.checked = false;
				this.steps[index].checked = false;
			}
		},
		dragOptions() {
			this.enableOptions = true;
		},
		getThematicId(id) {
			this.id = id;
			this.thematics[id].isSelected = this.thematics[id].isSelected === false;
			for (let i = 0; i < this.thematics.length; i++) {
				if (i !== id) {
					this.thematics[i].isSelected = false;
				}
			}
		},
		getLanguagesId(id) {
			this.id = id;
			this.destinationLanguages[id].isSelected = true;
			for (let i = 0; i < this.destinationLanguages.length; i++) {
				if (i === id) {
					this.finalDestLang = this.destinationLanguages[i].lang;
				}
				else {
					this.destinationLanguages[i].isSelected = false;
				}
			}
		},
		selectDestLang() {
			this.destinationLanguages = [];
			let check = function (element) {
				return element.checked === true && element.isCompleted === true;
			};
			let $this = this;
			let tmpArray = [];
			if ($this.steps.some(check)) {
				$this.steps.filter(step => check(step) && Array.isArray(step.destLang)).forEach(function (element) {
					tmpArray.push(element.destLang);
				});

				$this.destinationLanguages.push({
					"lang": "false",
					"img": "./static/images/flag_no.png",
					"isSelected": true,
				});

				if (tmpArray.length > 0) {
					let result = tmpArray.shift().reduce(function (res, v) {
						if (res.indexOf(v) === -1 && tmpArray.every(function (a) {
							return a.indexOf(v) !== -1;
						})) {
							res.push(v);
						}
						return res;
					}, []);
					if (result.length > 0) {
						result.forEach(function (item) {
							if (item !== null && item !== undefined) {
								$this.destinationLanguages.push({
									"lang": item,
									"img": "./static/images/flag" + item + ".png",
									"isSelected": false,
								});
							}
						});
					}
				}

				$this.titleDestLangModal = "Ce projet comporte les langues de sous-titrages disponibles ci-dessous. " +
					"Sélectionnez celle que vous souhaitez pour votre vidéo finale et recommencez l'opération autant de fois " +
					"que de langues différentes de sous-titrage souhaitées (affichage langue).";
				$this.destLangWarning = "Vous ne pouvez pas compiler une " +
					"seule vidéo avec des sous-titres de langues différentes, il est donc nécessaire que chacune de vos étapes " +
					"projets possède une langue commune de destination.";
				$this.$refs.finalDestLangModal.show();
			}
			else {
				$this.text_error = "Vous ne pouvez pas compiler votre projet si ce dernier ne contient pas d'étapes.";
				$this.$refs.modalError.show();
			}
		},
		countInArray(array, what) {
			let count = 0;
			for (let i = 0; i <= array.length; i++) {
				if (array[i] === what) {
					count++;
				}
			}
			return count;
		},
		sendDatas(format) {
			let array = this.steps.filter(function (step) {
				return step.isCompleted === true && step.checked === true;
			});
			let destLang = this.finalDestLang;

			this.$refs.finalDestLangModal.hide();
			this.$refs.loaderModal.show();
			axios.post(BASE_URL + "/public/api/projects/" + this.$route.params.id + "/compil", {
				data: array,
				id: this.$route.params.id,
				format: format,
				music_volume: this.music_volume,
				destLang: destLang,
				userLang: this.$root.$t('current_lang'),
				username: sessionStorage.getItem("username"),
			}, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			}).then(response => {
				this.$refs.loaderModal.hide();
				this.previewVideo(response.data.data.video_absolute_url + "#" + new Date().getTime());
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		previewVideo(data) {
			this.videoPath = data;
			this.$refs.previewModal.show();
		},
		closePreview() {
			this.$refs.previewModal.hide();
		},
		stopVideo() {
			if (this.$refs.playerpreview.played) {
				this.$refs.playerpreview.pause();
			}

			// Open notification box
			// this.$refs.notificationModal.show();
			this.$router.push({name: "Dashboard"});
		},
		gotoDashboard() {
			this.$router.push({name: "Dashboard"});
		},
		send_notif() {
			axios.get(BASE_URL + "/public/api/projects/" + this.$route.params.id + "/notification", {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(response => {
				this.gotoDashboard();
			});
		},
	},
};
</script>

<style scoped>
.btn-valid {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
}

.btn-export {
	background-color: var(--color-export);
	border-color: var(--color-export);
	color: var(--text-export);
}

.col-left {
	text-align: left;
}

.col-right {
	text-align: right;
}

.scrollpanel {
	height: 400px;
	width: 600px;
	overflow: auto;
}

.form-group {
	margin-bottom: 0;
}

.list_steps {
	border: 1px #8AA0B2 solid;
	margin-bottom: -1px;
	cursor: n-resize;
	transition: all .7s;
	display: grid;
	grid-template-areas:
		"icon name input"
		"icon preview input";
	grid-template-columns: 40px auto 40px;
	grid-template-rows: 1fr 1fr;
}

.list_steps:first-child {
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
}

.list_steps:last-child {
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}

.list-complete-enter, .list-complete-leave-active {
	opacity: 0;
}

.step-icon {
	grid-area: icon;
	place-self: center;
}

.checkbox_steps {
	vertical-align: middle;
	float: right;
	grid-area: input;
	place-self: center;
	width: 20px;
	height: 20px;
}

.subtitle_box {
	margin: 0 10px 10px;
}

.subtitle_btn {
	text-align: center;
	padding: 20px;
	opacity: .7;
	border-radius: var(--small-border-radius);
	margin: 0 10px;
}

.subtitle_btn:hover {
	box-shadow: 0 0 15px #00000080;
}

.subtitle_btn.selected {
	outline: 3px solid var(--color-main-action);
}

.subtitle_btn img {
	text-align: center;
	height: 100px;
	width: 100px;
//opacity: .5;
}

.subtitle_btn p {
	margin: 10px 0 0;
}

.selected {
	opacity: 1;
}

.subtitle_lang {

}

.step-name {
	grid-area: name;
	padding-top: 5px;
	font-size: 1.1em;
	align-self: stretch;
}

.step-info {
	grid-area: preview;
	padding-bottom: 5px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	font-style: italic;
}

.step-info span {
}

.video-popup {
	background: #2C2A29;
}

.btn-download {
	background: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
}

.btn-close-preview {
	background: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
}

</style>
